<template>
  <div class="create_survey_summary_modal">
    <UeModal
      title="Generate Survey Summary"
      name="create_survey_summary_modal"
      @before-open="beforeOpen"
    >
      <div v-if="surveySummary">
        <label>Summary Name</label>
        <b-input placeholder="" v-model="surveySummary.title" />
      </div>
      <template #footer>
        <div class="d-flex w-100 justify-content-end">
          <b-button variant="primary" @click.stop="createSummary" data-cy="create-survey-summary">
            <b-icon-stars class="mr-2" />
            Generate Summary
          </b-button>
        </div>
      </template>
    </UeModal>
  </div>
</template>
<script lang="ts">
import { createSurveySummary, newSurveySummary } from '@app/api.js'
import { trackEvent } from '@lib/tracking'

export default {
  data() {
    return {
      surveySummary: null,
      surveyId: null,
    }
  },
  methods: {
    beforeOpen(e) {
      this.surveyId = e.params.surveyId
      // Initializing this object on the backend since the logic (specifically default name)
      // is much easier to do there.
      newSurveySummary(this.surveyId).then(
        (response) => (this.surveySummary = response.data.survey_summary),
      )
    },
    createSummary() {
      createSurveySummary(this.surveyId, this.surveySummary).then(() => {
        trackEvent('survey summary created', { survey_id: this.surveyId })
        this.gotoIndex()
      })
    },
    gotoIndex() {
      this.$closeModal('create_survey_summary_modal')
      // This routing logic encompasses the old responses UX that'll eventually be removed (the one
      // at route name survey-summaries) and the new experience at route name responses:survey:summaries
      if (
        this.$route.name === 'survey-summaries' ||
        this.$route.name === 'responses:survey:summaries'
      ) {
        // This go() will reload the current page
        // It's a hacky way to make sure the newly added summary is displayed,
        // to do it the proper way we'll need to add pinia plumbing in the future
        // if this feature sticks around.
        this.$router.go()
      } else if (this.$route.name.includes('responses')) {
        this.$router.push({
          name: 'responses:survey:summaries',
          params: { surveyId: this.surveyId },
        })
      } else {
        this.$router
          .push({ name: 'survey-summaries', params: { surveyId: this.surveyId } })
          .then(() => this.$toast('Survey summary created successfully'))
      }
    },
  },
}
</script>
